import { ReferenceInput, AutocompleteInput, required } from "react-admin";
import { SchoolIdSelected } from "utils/tools";

interface IStudentInput {
  disabled?: boolean;
}

const StudentInput = ({ disabled }: IStudentInput) => {
  return (
    <ReferenceInput
      source="studentId"
      label="Select Student"
      reference="students"
      filter={{
        SchoolId: Number(SchoolIdSelected()),
        IsMain: true,
      }}
      validate={required()}
      disabled={disabled}
      filterToQuery={(searchText: any) => {
        if (searchText !== "") return { search: searchText };
      }}
    >
      <AutocompleteInput
        optionText={(choice: any) =>
          `${choice.firstName} ${choice.lastName} (ID: ${choice.id})`
        }
      />
    </ReferenceInput>
  );
};

export default StudentInput;
